import minOrder from './min-order';
export * from './min-order';

export default { minOrder };
